module.exports = __webpack_public_path__ + "img/UTESCA-6.2827afb4.jpg";